import {uniqueId} from 'lodash'

const routeToClientCard = {
  name: 'ContactCard',
  params: {
    id: 'id'
  },
  paramName: 'id',
  paramValue: 'client.id',
  props: true
}

const columns = [
  {
    title: 'COMPLETION DATE',
    prop: 'approvedDate',
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    typeTable: 'kpiInfo',
    padding: true,
    pointer: true,
    sortBy: 'approvedDate',
    width: 'minmax(147px, 179px)'
  },
  {
    title: 'CLIENT',
    prop: 'client.name',
    route: routeToClientCard,
    hover: true,
    typeTable: 'kpiInfo',
    width: 'minmax(80px, 174px)'
  },
  {
    title: 'SERVICE',
    prop: 'service.name',
    nameRoute: 'ProjectCard',
    nameProject: {
      display: 'project.name',
      text: 'project.name'
    },
    spaceBetween: true,
    checkRoute: 'serviceProjectManagerInstanceIdIsDelete',
    billet: {
      text: ['Transfer', 'Dues paid', 'Split %'],
      display: ['isTransfer', 'isDouble', 'project.kpiHelpUsers.length']
    },
    enum: {
      prop: 'createType',
      getter: (val) => {
        switch (val) {
        case 2:
          return 'Proj'
        case 3:
          return 'Inv'
        default:
          return ''
        }
      }
    },
    width: 'minmax(190px, 268px)'
  },
  {
    title: 'PROFORMA NO.',
    prop: 'invoice.number',
    hover: true,
    actionType: 'openProforma',
    typeTable: 'kpiInfo',
    width: 'minmax(100px, 193px)'
  },
  {
    title: 'INVOICED',
    prop: 'amount',
    type: 'number',
    padding: true,
    width: 'minmax(77px, 103px)'
  },
  {
    title: 'RECEIVED',
    prop: 'currentValue',
    typeTable: 'kpiInfo',
    padding: true,
    type: 'number',
    width: 'minmax(62px, 146px)'
  },
  {
    title: 'FACT',
    prop: 'factValue',
    editable: true,
    typeEditable: 'number',
    type: 'number',
    customClass: (value) => value < 0 ? 'bb-negative-number' : '',
    info: {
      display: 'project.managerComment',
      text: 'project.managerComment'
    },
    error: 'factError',
    notMore: 'assignedValue',
    width: 'minmax(103px, 144px)'
  },
  {
    title: 'KPI EARNED',
    prop: 'approvedValue',
    typeTable: 'kpiInfo',
    hoverClass: 'bb-block_hover',
    height: true,
    type: 'number',
    background: true,
    customClass: (value) => value < 0 ? 'bb-block bb-block__negative-number' : 'bb-block bb-block__center'
  },
  {
    title: 'KPI EARNED, %',
    prop: 'assignedPercent',
    postfix: '%',
    background: true,
    height: true,
    customClass: () => {
      return 'bb-block'
    },
    hoverClass: 'bb-block_hover',
    width: 'minmax(110px, 132px)',
    padding: true
  },
  {
    bonusKPI: true,
    duplicateKPI: true,
    commentApproval: true,
    prop: 'isBonus',
    propertyAlt: 'isDouble',
    type: 'bonusCell',
    propertyApp: 'managerComment'
  }
]

const prefix = 'kpi_earned_column_'
const kpiEarnedTableColumns = columns.map(col => {
  col.mark = 'earned'
  col.id = uniqueId(prefix)
  return col
})

export default kpiEarnedTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/kpiEarnedTable.js